export default __webpack_public_path__ + "static/media/IMG-20240729-WA0029.f6564c48.jpg";